var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 6.00011C21.69 6.35011 20.86 6.58011 20 6.69011C20.88 6.16011 21.56 5.32011 21.88 4.31011C21.05 4.81011 20.13 5.16011 19.16 5.36011C18.37 4.50011 17.26 4.00011 16 4.00011C13.65 4.00011 11.73 5.92011 11.73 8.29011C11.73 8.63011 11.77 8.96011 11.84 9.27011C8.28001 9.09011 5.11001 7.38011 3.00001 4.79011C2.63001 5.42011 2.42001 6.16011 2.42001 6.94011C2.42001 8.43011 3.17001 9.75011 4.33001 10.5001C3.62001 10.5001 2.96001 10.3001 2.38001 10.0001V10.0301C2.38001 12.1101 3.86001 13.8501 5.82001 14.2401C5.19073 14.4123 4.5301 14.4363 3.89001 14.3101C4.16161 15.1626 4.69354 15.9085 5.41102 16.443C6.1285 16.9776 6.99545 17.2738 7.89001 17.2901C6.37364 18.4905 4.494 19.1394 2.56001 19.1301C2.22001 19.1301 1.88001 19.1101 1.54001 19.0701C3.44001 20.2901 5.70001 21.0001 8.12001 21.0001C16 21.0001 20.33 14.4601 20.33 8.79011C20.33 8.60011 20.33 8.42011 20.32 8.23011C21.16 7.63011 21.88 6.87011 22.46 6.00011Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.2dbfcce4aa8742cd8e9dc82138e87a84.svg";
export { ForwardRef as ReactComponent };